import { TravelInsuranceType } from '../../types/cmsEnums';
import { CmsProduct } from '../../types/cmsProduct';

export const SINGLE_PLAN_CATEGORY_IDENTIFIER = 'category:single-plan-travel';
export const ANNUAL_PLAN_CATEGORY_IDENTIFIER = 'category:annual-plan-travel';

/**
 * CMS-1851: a product's own trip type from its category identifiers.
 * Both identifiers → Single wins; neither → undefined (page filter stays
 * the source of truth).
 */
export const getTripTypeFromCategoryIdentifiers = (
  categoryIdentifiers?: ReadonlyArray<string | undefined>,
): TravelInsuranceType | undefined => {
  if (categoryIdentifiers?.includes(SINGLE_PLAN_CATEGORY_IDENTIFIER)) {
    return 'SINGLE_PLAN';
  }

  if (categoryIdentifiers?.includes(ANNUAL_PLAN_CATEGORY_IDENTIFIER)) {
    return 'ANNUAL_PLAN';
  }

  return undefined;
};

export const getCmsProductTripType = (
  product?: CmsProduct,
): TravelInsuranceType | undefined =>
  getTripTypeFromCategoryIdentifiers(product?.category_identifiers);
